import { Inline, Stack, Text } from "@origin-digital/ods-core";
import { formatLabel } from "@/utils";
import React from "react";
import { solarBatteryOutlook as content } from "../content.json";
import SunAndBatteryIllustration from "@/assets/sunAndBattery.svg";
import SunAndBatteryNoCoverIllustration from "@/assets/sunAndBatteryNoCover.svg";

export const Outcome = ({
  biggestBatterySize,
  isBatterySuported,
}: {
  biggestBatterySize: number;
  isBatterySuported: boolean;
}) => {
  return isBatterySuported ? (
    <Inline space={"medium"} alignY={"center"} disableWrap={true}>
      <SunAndBatteryIllustration />
      <Stack space={"none"}>
        <Text variant={"subtitle-small"} tone={"neutralDark"}>
          <b>
            {formatLabel(
              content.batteryOutcome.title,
              (value) => (
                <>{value}</>
              ),
              biggestBatterySize
            )}
          </b>
        </Text>
        <Text tone={"neutralDark"}>
          {content.batteryOutcome.descriptionCoverTitle}
        </Text>
      </Stack>
    </Inline>
  ) : (
    <Inline space="medium" alignY="center" disableWrap={true}>
      <SunAndBatteryNoCoverIllustration />
      <Stack space="small">
        <Text tone="neutralDark">
          <b>{content.batteryOutcome.solarGenerationNeeded.capacityRequired}</b>
        </Text>
      </Stack>
    </Inline>
  );
};
